import Swiper from 'swiper';
import {EffectCoverflow, EffectCards, Pagination} from 'swiper/modules';

window.initTicketSlider = function () {
    const selector = '.js-ticket-slider',
        slider = document.querySelector(selector);

    if (slider) {
        const slides = Array.from(slider.querySelectorAll('.swiper-slide')),
            initialSlide = slides.findIndex(item => item.classList.contains('j-active')) ?? 0;
        const ticketSlider = new Swiper(selector, {
            modules: [EffectCoverflow, EffectCards, Pagination],
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 0,
                scale: 0.8,
                stretch: 1,
                depth: 150,
                modifier: 1,
                slideShadows: false,
            },
            initialSlide: initialSlide,
            centeredSlides: true,
            slidesPerView: 1.9,
            spaceBetween: 24,
            slideToClickedSlide: true,
            pagination: {
                el: '.js-ticket-slider-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 1.9,
                    spaceBetween: 24,
                },
            },
            on: {
                init: (swiper) => {
                    const tabSelectionEls = Array.from(document.querySelectorAll('.js-ticket-slider-tab'));
                    tabSelectionEls.forEach((tabSelectionEl) => {
                        if (tabSelectionEl && tabSelectionEl.children.length > 0) {
                            const childElements = Array.from(tabSelectionEl.children);
                            childElements.forEach((item, index) => {
                                item.addEventListener('click', () => {
                                    swiper.slideTo(index);
                                });
                            });
                        }
                    });
                },
                slideChange: (swiper) => {
                    const tabSelectionEls = Array.from(document.querySelectorAll('.js-ticket-slider-tab'));
                    tabSelectionEls.forEach((tabSelectionEl) => {
                        if (tabSelectionEl && tabSelectionEl.children[swiper.activeIndex]) {
                            const button =
                                tabSelectionEl.children[swiper.activeIndex].querySelector('.js-tab-list-button');
                            button.click();
                        }
                    });
                },
            },
        });
        return ticketSlider;
    }
}
document.addEventListener('DOMContentLoaded', () => {
    initTicketSlider();
});
